import { Actions } from './property-type-templates.actions'
import { fromJS } from 'immutable'
import * as templatesTypes from './property-type-templates.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    pagination: {
      page: 1,
      page_size: 20,
      // order_by: 'createdAt',
      // sort: 'desc',
    },
    total: 0,
    filtered: 0,
  },
  createTemplate: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateTemplate: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function propertyTypeTemplatesReducer(
  state = initialState,
  action: Actions,
) {
  switch (action.type) {
    case templatesTypes.UPDATE_PROPERTY_TYPE_TEMPLATE_REQUEST: {
      return state.setIn(['updateTemplate', 'isLoading'], true)
    }

    case templatesTypes.UPDATE_PROPERTY_TYPE_TEMPLATE_SUCCESS: {
      return state.setIn(['updateTemplate', 'isLoading'], false)
    }

    case templatesTypes.UPDATE_PROPERTY_TYPE_TEMPLATE_FAILURE: {
      return state.setIn(['updateTemplate', 'isLoading'], false)
    }

    case templatesTypes.CREATE_PROPERTY_TYPE_TEMPLATE_REQUEST: {
      return state.setIn(['createTemplate', 'isLoading'], true)
    }

    case templatesTypes.CREATE_PROPERTY_TYPE_TEMPLATE_SUCCESS: {
      return state.setIn(['createTemplate', 'isLoading'], false)
    }

    case templatesTypes.CREATE_PROPERTY_TYPE_TEMPLATE_FAILURE: {
      return state.setIn(['createTemplate', 'isLoading'], false)
    }

    case templatesTypes.DELETE_PROPERTY_TYPE_TEMPLATE_REQUEST: {
      return state
    }

    case templatesTypes.DELETE_PROPERTY_TYPE_TEMPLATE_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case templatesTypes.DELETE_PROPERTY_TYPE_TEMPLATE_FAILURE: {
      return state
    }

    case templatesTypes.FETCH_PROPERTY_TYPE_TEMPLATES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case templatesTypes.FETCH_PROPERTY_TYPE_TEMPLATES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.count))
        .setIn(['list', 'filtered'], fromJS(action.filtered))
    }

    case templatesTypes.FETCH_PROPERTY_TYPE_TEMPLATES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case templatesTypes.FETCH_PROPERTY_TYPE_TEMPLATE_REQUEST: {
      return state.setIn(['updateTemplate', 'isLoading'], true)
    }

    case templatesTypes.FETCH_PROPERTY_TYPE_TEMPLATE_SUCCESS: {
      return state
        .setIn(['updateTemplate', 'isLoading'], false)
        .setIn(['updateTemplate', 'data'], fromJS(action.payload))
    }

    case templatesTypes.FETCH_PROPERTY_TYPE_TEMPLATE_FAILURE: {
      return state.setIn(['updateTemplate', 'isLoading'], false)
    }

    case templatesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case templatesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
